"use client";
import * as React from "react";
const SvgExternalRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 9.78v4.44c0 .98-.8 1.78-1.78 1.78H1.78C.8 16 0 15.2 0 14.22V1.78C0 .8.8 0 1.78 0h4.44c.5 0 .9.4.9.89s-.4.89-.9.89H2.67a.9.9 0 0 0-.9.89v10.66c0 .5.4.9.9.9h10.66a.9.9 0 0 0 .9-.9V9.78c0-.5.4-.9.88-.9.49 0 .89.4.89.9M7.51 7.22a.9.9 0 0 0 0 1.25.9.9 0 0 0 1.25 0l5.45-5.45V5.4a.9.9 0 0 0 1.78 0V.89a.9.9 0 0 0-.88-.89H10.6c-.5 0-.9.4-.9.89s.4.89.9.89h2.36z" }));
export {
  SvgExternalRound as default
};
